export default function LoadMorePagination() {
  function revealPostCards() {
    const postCards = document.querySelectorAll('.animate-slide-up');
  
    function isInViewport(element) {
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      return rect.bottom >= 0 && rect.top <= windowHeight;
    }
  
    postCards.forEach((card) => {
      if (isInViewport(card)) {
        card.classList.add('is-visible');
      }
    });
  }
  
    // Hide the load more button
    function hideLoadMoreButton() {
      if (loadMoreButton) {
        loadMoreButton.style.display = 'none';
      }
    }
  
    // Append HTML elements to a wrapper element
    function appendElements(wrapper, elements) {
      elements.forEach(function(element) {
        wrapper.appendChild(element);
      });
    }
  
    // Update pagination state and button status
    function updatePaginationState() {
      pagination_next_page_number++;
      loadMoreButton.classList.remove('loading');
      loadMoreButton.disabled = false;
  
      if (pagination_next_page_number > pagination_available_pages_number) {
        loadMoreButton.disabled = true;
      }
    }
  
    // Handle click event for the load more button
    function handleLoadMoreClick(e) {
      e.preventDefault();
      loadMoreButton.classList.add('loading');
      loadMoreButton.disabled = true;
  
      if (pagination_next_page_number <= pagination_available_pages_number) {
        var url = nextPageUrl.split(/page/)[0] + 'page/' + pagination_next_page_number + '/';
        fetch(url)
          .then(function(response) {
            if (response.ok) {
              return response.text();
            }
          })
          .then(function(data) {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = data;
            var wrapper = document.querySelector('.v-postfeed');
            var html = Array.from(tempDiv.querySelectorAll('.post'));
            appendElements(wrapper, html);
            updatePaginationState();
            revealPostCards();
          });
      }
    }
  
    // Main script
    var nextLink = document.querySelector('link[rel=next]');
    var nextPageUrl, loadMoreButton, endMessage;
  
    // Check if there is a next link
    if (nextLink !== null) {
      nextPageUrl = nextLink.getAttribute('href');
      loadMoreButton = document.querySelector('.v-load-posts');
  
      // Check if the next page URL is undefined
      if (typeof nextPageUrl === 'undefined') {
        hideLoadMoreButton();
      } else {
        // Attach click event handler to the load more button
        loadMoreButton.addEventListener('click', handleLoadMoreClick);
      }
    } else {
      var paginationWrap = document.querySelector('.v-pagination');
      // Hide the load more button if there is no next link and a pagination wrapper is present
      if (paginationWrap !== null) {
        hideLoadMoreButton();
      }
    }
  }
  
